var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomDogSniff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,252c-90.239,0-175,121.649-175,195c0,36.449,41.729,65,95,65c20.036,0,33.468-4.429,45.319-8.336    C232.165,500.088,241.532,497,256,497c14.468,0,23.835,3.088,34.681,6.664C302.532,507.571,315.964,512,336,512    c53.271,0,95-28.551,95-65C431,373.649,346.238,252,256,252z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166,0c-42.056,0-75,50.514-75,115s32.944,115,75,115c42.056,0,75-50.514,75-115S208.056,0,166,0z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346,0c-42.056,0-75,50.514-75,115s32.944,115,75,115c42.056,0,75-50.514,75-115S388.056,0,346,0z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.343,233.193C85.963,194.758,48.885,181,23.212,195.741C-2.711,210.624-8.115,250,13.08,288.193    C34.396,326.602,73.552,340,98.212,325.645C123.418,310.971,130.552,271.334,108.343,233.193z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.788,195.74c-25.673-14.741-62.751-0.983-85.131,37.452c-22.209,38.141-15.075,77.778,10.131,92.452    c24.66,14.356,63.816,0.958,85.131-37.452C520.115,249.999,514.71,210.624,488.788,195.74z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomDogSniff);
export default __webpack_public_path__ + "static/media/random-dog-sniff.5b9c5de1f88f9d6d02a360441ee13316.svg";
export { ForwardRef as ReactComponent };